import * as Sentry from '@sentry/react'
import UpshowLogger from '../Logger';
import SettingsService from './SettingsService';
import packageInfo from '../../package.json';

const { name, version } = packageInfo;

let isSentryClosed = false;

function isSentryInitialized() {
    return Sentry.getCurrentHub().getClient() !== undefined;
}

export function setupSentry() {
    if (isSentryInitialized() && !isSentryClosed) return;

    try {
        Sentry.init({
            dsn: process.env.REACT_APP_SENTRY_DSN,
            sampleRate: 0.1,
            enabled: !!+process.env.REACT_APP_SENTRY_ENABLED,
            environment: process.env.NODE_ENV,
            release: name + '@' + version,
        });
        window.enable_sentry = true;
        isSentryClosed = false;
    } catch (error) {
        UpshowLogger.error('Sentry', 'Error Initializing Sentry' + error);
    }

    const deviceId = SettingsService.getSetting('device_id');

    if (deviceId && isSentryInitialized) {
        Sentry.setUser({ id: deviceId })
    }
}

export function closeSentryClient() {
    if (isSentryInitialized()) {
        Sentry.getCurrentHub().getClient().close(2000);
        window.enable_sentry = false;
        isSentryClosed = true;
    }
}
